<template>
	<div id="App">
		<v-app>
			<v-main class="appBackground">
				<v-container class="fullheight pa-0" fluid>
					<router-view />
				</v-container>
			</v-main>
			<v-snackbar
				app
				:timeout="dsnackbar.timeout"
				v-model="dsnackbar.show"
				:color="dsnackbar.color ? dsnackbar.color : ''"
				:vertical="dsnackbar.multiLine">
				{{ dsnackbar.text }}
				<template v-slot:action="{ attrs }">
					<template v-if="dsnackbar.actions">
						<v-btn v-for="btn in dsnackbar.actions" :key="btn.actionText" text @click="btn.action" v-bind="attrs">
							{{ btn.actionText }}
						</v-btn>
					</template>
				</template>
			</v-snackbar>
		</v-app>
	</div>
</template>

<script lang="ts">
import EventBus from "@/EventBus";
import { mapGetters } from "vuex";
import MutationNames from "@/store/MutationsNames";
import Vue from "vue";
import SnackbarAction from "./types/SnackbarAction";

export default Vue.extend({
	name: "App",
	data() {
		return {
			dsnackbar: {
				text: "",
				timeout: 3000,
				show: false,
				color: null as string | null,
				actions: null as SnackbarAction[] | null,
				multiLine: false,
			},
		};
	},
	computed: {
		...mapGetters(["lightTheme"]),
	},
	created() {
		this.$vuetify.theme.dark = !this.lightTheme;
		EventBus.$on("snackbar", this.showSnackbar);
		EventBus.$on("snackbar:hide", this.hideSnackbar);
		EventBus.$on("login-needed", () => {
			this.$store.commit(MutationNames.resetStore);
			this.$router.replace({ name: "login" });
		});
		window.addEventListener("login-needed", this.goToLogin);
	},
	beforeDestroy() {
		window.removeEventListener("login-needed", this.goToLogin);
	},
	methods: {
		showSnackbar(message: string, timeout?: number, color?: string, multiLine?: boolean, actions?: SnackbarAction[]) {
			this.dsnackbar.text = message;
			this.dsnackbar.timeout = timeout ?? 3000;
			this.dsnackbar.show = true;
			this.dsnackbar.color = color ?? null;
			this.dsnackbar.actions = actions || [{ actionText: "Close", action: () => EventBus.$emit("snackbar:hide") }];
			this.dsnackbar.multiLine = multiLine ?? false;
		},
		hideSnackbar() {
			this.dsnackbar.show = false;
		},
		goToLogin() {
			this.$router.replace({ name: "signIn" });
		},
	},
});
</script>

<style scoped>

</style>
<style>
.clickable {
    cursor: pointer;
}
.fullwidth, .full-width {
	width: 100%;
}
.fullheight, .full-height {
	height: 100%;
}
.center-h {
	margin-left: auto;
	margin-right: auto;
}

html.fh {
	height: 100vh;
	overflow-y: hidden;
}

html.fh body, html.fh #App, html.fh #app, html.fh .v-application--wrap, html.fh .v-main, html.fh .v-main__wrap > .container {
	height: 100%;
}

/** prevent date text field from overflowing on x in small places on chrome */
.v-text-field__slot {
	width: 100%;
}

.hidden {
	visibility: hidden;
}

.hint {
	font-style: italic;
	color: var(--v-textColor-lighten5);
}
.discreet--text {
	color: var(--v-textColor-lighten5);
}

.shadow-text--black {
	text-shadow: black 1px 0 10px !important;
}

.row {
	margin-top: 0px !important;
	margin-bottom: 0px !important;
	flex-grow: 0 !important;
}

:root {
	--radius: 18px;
}

</style>
